module.exports = __webpack_public_path__ + "CorporateALight.woff";